// settings-panel.js
import { qs } from './utils.js';

/** Wires present sound-setting controls to a manager; absent controls are a no-op. @param {import('./sound-manager.js').default} soundManager @returns {void} */
export function wireSettingsPanel(soundManager) {
  const panel = qs('#wp-settings-panel');
  const btn = qs('#wp-settings-toggle');
  if (!panel || !btn) return;
  const elEnabled = qs('#wp-snd-enabled', panel);
  const elVol = qs('#wp-snd-vol', panel);
  const elPrep = qs('#wp-snd-prep', panel);
  if (!elEnabled || !elVol || !elPrep) return;
  const apply = () => {
    elEnabled.checked = !!soundManager.settings.enabled;
    elVol.value = String(soundManager.settings.volume ?? 1);
    elPrep.checked = !!soundManager.settings.prepBeeps;
  };
  apply();
  btn.addEventListener('click', () => panel.classList.toggle('open'));
  elEnabled.addEventListener('change', () => soundManager.setEnabled(elEnabled.checked));
  elVol.addEventListener('input', () => soundManager.setVolume(parseFloat(elVol.value || '1')));
  elPrep.addEventListener('change', () => soundManager.setPrepBeeps(elPrep.checked));
}
